import { __rest, __assign } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgCrossSmall } from './svg/cross-small.svg.js';

/**
 * @deprecated - use Cross.
 *
 * @param {boolean} legacyBoundingBox - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {number} size - (optional) This prop has no effect on legacy icons with the Mid or Small name suffix.
 * @param {string} title - (optional) will be applied as `aria-label` unless an `aria-label` is explicitly set.
 */
var CrossSmall = function (props) {
    var title = props.title; props.size; props.legacyBoundingBox; var rest = __rest(props, ["title", "size", "legacyBoundingBox"]);
    return (jsx(SvgCrossSmall, __assign({ viewBox: "-6 -6 36 36", "aria-label": title, role: "img" }, rest, { width: 24, height: 24, "data-pp-icon": "CrossSmall" })));
};

export { CrossSmall as default };
//# sourceMappingURL=CrossSmall.js.map
